/* MXDVS newsletter window.
   Opens after a delay (never on top of the cookie window), prompt-line
   email field with a block cursor, and shows the result screen in the window.
   06.10.2026: faster 10% email. The address is also sent straight to Klaviyo's
   Email List (list XdHuwg, single opt-in, client subscribe request), so the
   welcome flow starts right away. (Until 08.10.2026 Shopify's customer form
   was the backup; see below.)
   06.10.2026 (later): every sign-up also gets the Klaviyo profile property
   "MXDVS Signup Source", in a separate small request, so the team can see where
   each subscriber signed up.
   07.10.2026: sends exactly like the footer sign-up (assets/mxdvs-footer-newsletter.js):
   - no page reload: the result screen (Code sent / Already registered /
     Not sent) opens in the window;
   - labels for the welcome flow (asked by Seppe, approved by Max): source
     "MXDVS welcome popup", MXDVS Signup Source "welcome-popup";
   - typing error fallbacks: the footer's 4 messages (the shared email check in
     assets/mxdvs-email-check.js normally answers first);
   - addresses that signed up here or in the footer are remembered in this browser
     (shared with the footer), so they get "Already registered" straight away.
   08.10.2026: sends to Klaviyo only (no Shopify form, so no hCaptcha badge), same
   as the footer sign-up. The form is detached from Shopify at start (no action,
   no form_type). Klaviyo's answer decides the screen: Code sent, or Not sent.
   Spam guards before sending: a hidden trap field (filled: success screen,
   nothing sent), throwaway addresses are refused, and at most 5 sign-ups per
   hour per device (localStorage 'mxnl_log', shared with the footer).
   The old "back from Shopify's check page" step below only runs for a leftover
   note from before this change; nothing sets it any more.
   09.10.2026: before subscribing it asks CR whether the address is already
   subscribed in Klaviyo (name+tag@ checked as name@); yes: Already registered,
   nothing sent. No answer within 2.5 seconds: the sign-up goes ahead as before. */
(function(){
  'use strict';

  var DISMISS_KEY='mxnl_dismissed_at';
  var DONE_KEY='mxnl_subscribed';
  var LIST_KEY='mxnl_emails';
  var PENDING_KEY='mxnl_pending';
  var EMAIL=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var GL='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*+=<>';
  var reduced=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* only screens with a mouse get the cursor in the email field automatically;
     on phones it made iPhones zoom in on the page (30.09.2026) */
  var canHover=window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches;
  var sleep=function(ms){return new Promise(function(r){setTimeout(r,ms)})};
  function lsGet(k){try{return localStorage.getItem(k)}catch(e){return null}}
  function lsSet(k,v){try{localStorage.setItem(k,v)}catch(e){}}
  function ssGet(k){try{return sessionStorage.getItem(k)}catch(e){return null}}
  function ssSet(k,v){try{sessionStorage.setItem(k,v)}catch(e){}}
  function ssDel(k){try{sessionStorage.removeItem(k)}catch(e){}}
  function knownEmails(){try{return JSON.parse(lsGet(LIST_KEY))||[]}catch(e){return []}}
  function rememberEmail(em){var l=knownEmails();if(l.indexOf(em)<0){l.push(em);lsSet(LIST_KEY,JSON.stringify(l.slice(-20)))}}

  /* ---------- Klaviyo: subscribe straight to the Email List ----------
     Klaviyo's client requests (public key only, made for browsers).
     08.10.2026: Klaviyo is the only send; the subscription's answer decides the
     result screen (klaviyoSubscribeChecked).
     Two requests: the subscription (starts the welcome flow) and, separately,
     the profile property "MXDVS Signup Source" (never delays or breaks the first). */
  var KL_BASE='https://a.klaviyo.com/client/';
  var KL_KEY='UKxycP';
  var KL_REVISION='2026-07-15';
  var KL_LIST='XdHuwg';
  var KL_SOURCE_PROP='MXDVS Signup Source';
  var KL_SOURCE='MXDVS welcome popup';
  var KL_SOURCE_KEY='welcome-popup';
  function klPost(path,payload){
    var body=JSON.stringify(payload);
    function go(keep){
      return fetch(KL_BASE+path+'/?company_id='+KL_KEY,{method:'POST',keepalive:keep,headers:{'Content-Type':'application/vnd.api+json','revision':KL_REVISION},body:body});
    }
    try{
      return go(true).catch(function(){return go(false)}).catch(function(){});
    }catch(e){return Promise.resolve()}
  }
  /* 08.10.2026: the subscription is the real send. Resolves true only when
     Klaviyo accepts it (202), false on any failure. The "MXDVS Signup Source"
     request goes out separately and never changes the result. */
  function klaviyoSubscribeChecked(email,source,sourceKey){
    var body=JSON.stringify({data:{
      type:'subscription',
      attributes:{
        custom_source:source,
        profile:{data:{type:'profile',attributes:{
          email:email,
          subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}
        }}}
      },
      relationships:{list:{data:{type:'list',id:KL_LIST}}}
    }});
    function go(keep){
      return fetch(KL_BASE+'subscriptions/?company_id='+KL_KEY,{method:'POST',keepalive:keep,headers:{'Content-Type':'application/vnd.api+json','revision':KL_REVISION},body:body});
    }
    var result;
    try{
      result=go(true).catch(function(){return go(false)})
        .then(function(r){return !!(r&&r.ok)},function(){return false});
    }catch(e){result=Promise.resolve(false)}
    try{
      var props={};props[KL_SOURCE_PROP]=sourceKey;
      klPost('profiles',{data:{type:'profile',attributes:{email:email,properties:props}}});
    }catch(e){}
    return result;
  }

  /* ---------- already-registered check (09.10.2026, launch item 27) ----------
     Before subscribing, ask CR (admin.mxdvs.co/api/nl/status) whether the address is
     already subscribed in Klaviyo. name+anything@ is checked as name@. CR only reads;
     the sign-up itself stays here. No answer within 2.5 seconds, or any error: carry on
     with the sign-up as before (the welcome flow still never sends a second code). */
  var CR_STATUS='https://admin.mxdvs.co/api/nl/status';
  var CR_WAIT=2500;
  function baseEmail(em){var p=String(em||'').split('@');return p.length===2?p[0].split('+')[0]+'@'+p[1]:em}
  function crRegistered(email,website){
    return new Promise(function(resolve){
      var done=false,ctrl=null;
      function end(v){if(done)return;done=true;clearTimeout(t);if(ctrl){try{ctrl.abort()}catch(e){}}resolve(v)}
      var t=setTimeout(function(){end(false)},CR_WAIT);
      try{
        ctrl=window.AbortController?new AbortController():null;
        fetch(CR_STATUS,{method:'POST',headers:{'Content-Type':'text/plain'},body:JSON.stringify({email:baseEmail(email),website:website||''}),signal:ctrl?ctrl.signal:undefined})
          .then(function(r){return r&&r.ok?r.json():null})
          .then(function(j){end(!!(j&&j.ok===true&&j.registered===true))},function(){end(false)});
      }catch(e){end(false)}
    });
  }
  function trapValue(form){var t=form&&form.querySelector('input[name="website"][data-mx-email-skip]');return t?t.value:''}

  /* ---------- spam guards (08.10.2026) ----------
     Same logic as the footer sign-up (assets/mxdvs-footer-newsletter.js): a hidden
     trap field (people never fill it), no throwaway addresses, at most 5 sign-up
     sends per hour per device (localStorage 'mxnl_log', shared with the footer;
     a time is only logged when a send goes out). */
  var LOG_KEY='mxnl_log',LOG_MAX=5,LOG_SPAN=3600000;
  var THROWAWAY=/@(?:[^@]*\.)?(mailinator|guerrillamail|guerrillamailblock|sharklasers|grr|10minutemail|tempmail|temp-mail|yopmail|trashmail|getnada|dispostable|maildrop|throwawaymail|fakeinbox|mintemail|mohmal|emailondeck|spamgourmet)\./i;
  function sendLog(){
    var now=Date.now(),l=[];
    try{l=JSON.parse(localStorage.getItem(LOG_KEY))||[]}catch(e){l=[]}
    if(!Array.isArray(l)) l=[];
    return l.filter(function(t){return typeof t==='number'&&now-t<LOG_SPAN});
  }
  function logSend(){
    var l=sendLog();
    l.push(Date.now());
    try{localStorage.setItem(LOG_KEY,JSON.stringify(l))}catch(e){}
  }
  function spamGuard(email){
    if(THROWAWAY.test(email)) return 'throwaway';
    if(sendLog().length>=LOG_MAX) return 'limit';
    return '';
  }
  function trapFilled(form){
    var t=form&&form.querySelector('input[name="website"][data-mx-email-skip]');
    return !!(t&&t.value);
  }
  /* detach the form from Shopify once: no action and no form_type, so Shopify's
     hCaptcha never attaches. contact[tags] and contact[email] stay. Adds the
     hidden trap field. */
  function detachFromShopify(form){
    if(!form||form.getAttribute('data-mx-klaviyo-only')==='1') return;
    form.removeAttribute('action');
    var drop=form.querySelectorAll('input[name="form_type"],input[name="utf8"]');
    for(var i=0;i<drop.length;i++) drop[i].parentNode.removeChild(drop[i]);
    if(!form.querySelector('input[name="website"]')){
      var trap=document.createElement('input');
      trap.type='text';
      trap.name='website';
      trap.tabIndex=-1;
      trap.setAttribute('tabindex','-1');
      trap.setAttribute('autocomplete','off');
      trap.setAttribute('aria-hidden','true');
      trap.setAttribute('data-mx-email-skip','');
      trap.setAttribute('style','position:absolute;left:-9999px;width:1px;height:1px;opacity:0');
      form.appendChild(trap);
    }
    form.setAttribute('data-mx-klaviyo-only','1');
  }

  function decode(el,txt,dur){
    if(!el) return;
    if(txt==null) txt=el.getAttribute('data-t')||el.textContent;
    el.setAttribute('data-t',txt);
    if(el._mxnlRaf) cancelAnimationFrame(el._mxnlRaf);
    if(reduced){el.textContent=txt;return}
    var start=performance.now();dur=dur||700;
    (function f(t){
      var k=Math.min(1,(t-start)/dur),out='';
      for(var i=0;i<txt.length;i++){var ch=txt[i];out+=(/[A-Za-z0-9]/.test(ch)&&i>=k*txt.length)?GL[(Math.random()*GL.length)|0]:ch}
      el.textContent=out;
      if(k<1) el._mxnlRaf=requestAnimationFrame(f);
    })(start);
  }

  function init(root){
    if(!root||root._mxnl) return;
    root._mxnl=true;

    var C={},COPY={};
    try{C=JSON.parse(root.querySelector('[data-mxnl-config]').textContent)}catch(e){}
    try{COPY=JSON.parse(root.querySelector('[data-mxnl-copy]').textContent)}catch(e){}
    function num(k,d){var v=parseFloat(C[k]);return isNaN(v)?d:v}
    var openDelay=num('openDelay',10),dismissDays=num('dismissDays',7);
    var design=!!(window.Shopify&&window.Shopify.designMode);

    if(root.parentNode!==document.body) document.body.appendChild(root);

    /* same corner and width as the cookie window */
    function matchCookie(){
      var c=document.querySelector('[data-mxcc]');if(!c) return;
      var cs=getComputedStyle(c),m=cs.getPropertyValue('--mxcc-m').trim(),w=cs.getPropertyValue('--mxcc-w').trim();
      if(m) root.style.setProperty('--mxnl-m',m);
      if(w) root.style.setProperty('--mxnl-w',w);
    }
    matchCookie();

    var form=root.querySelector('form');
    detachFromShopify(form);
    var input=root.querySelector('[data-mxnl-email]');
    var field=root.querySelector('[data-mxnl-field]');
    var blk=root.querySelector('[data-mxnl-blk]');
    var ph=root.querySelector('[data-mxnl-ph]');
    var msg=root.querySelector('[data-mxnl-msg]');
    var signup=root.querySelector('[data-mxnl-signup]');
    var resView=root.querySelector('[data-mxnl-result-view]');
    var resultFlag=(root.querySelector('[data-mxnl-result]')||{}).getAttribute?root.querySelector('[data-mxnl-result]').getAttribute('data-mxnl-result'):'';
    var measure=document.createElement('canvas').getContext('2d');
    var busy=false,wasValid=false,timer=null;

    /* ---------- open / close ---------- */
    function open(){
      root.hidden=false;
      requestAnimationFrame(function(){
        root.classList.add('is-open');
        if(!signup.hidden) place();
        root.querySelectorAll('[data-mxnl-dec]').forEach(function(s){decode(s,null,650)});
        if(!signup.hidden) root.querySelectorAll('[data-mxnl-ck]').forEach(function(el,i){
          el.style.visibility='hidden';
          /* lines with bold text or a link only fade in: decode would strip their markup (17.10.2026) */
          setTimeout(function(){el.style.visibility='';if(!el.children.length) decode(el,null,500)},reduced?0:250+i*220);
        });
        if(!signup.hidden) setTimeout(function(){place();if(canHover){try{input.focus({preventScroll:true})}catch(e){}}},400);
      });
    }
    function close(){
      root.classList.remove('is-open');
      clearTimeout(timer);
      if(!signup.hidden) allowed=false;
      if(!signup.hidden&&!design) lsSet(DISMISS_KEY,String(Date.now()));
      setTimeout(function(){if(!root.classList.contains('is-open')) root.hidden=true},500);
    }
    function showResult(kind){
      var c=COPY[kind]||COPY.ok||{};
      signup.hidden=true;resView.hidden=false;
      var t=resView.querySelector('[data-mxnl-res-title]');
      t.textContent=c.title||'';
      resView.querySelector('[data-mxnl-res-log]').textContent=c.log||'';
      resView.querySelector('[data-mxnl-res-text]').textContent=c.text||'';
      var n=resView.querySelector('[data-mxnl-res-note]');n.textContent=c.note||'';n.hidden=!c.note;
      open();
      decode(t,null,700);
    }
    /* the result screen, opened in place (no reload) */
    function finish(kind,email){
      busy=false;
      if(kind==='ok'||kind==='exists'){if(email){rememberEmail(email);lsSet(DONE_KEY,email)}}
      if(msg._mxnlRaf) cancelAnimationFrame(msg._mxnlRaf);
      msg.textContent='';msg.classList.remove('is-err');
      showResult(kind);
    }

    /* ---------- prompt line with block cursor ----------
       18.10.2026: the block cursor follows the text cursor position (arrow keys, clicks,
       selection, long addresses that scroll), holds still while typing and blinks again
       0.5 s after the last key. */
    function place(){
      var cs=getComputedStyle(input),host=field.getBoundingClientRect(),ir=input.getBoundingClientRect();
      measure.font=cs.fontWeight+' '+cs.fontSize+' '+cs.fontFamily;
      var v=input.value,pos=(input.selectionEnd==null?v.length:input.selectionEnd);
      var t=cs.textTransform==='uppercase'?v.slice(0,pos).toUpperCase():v.slice(0,pos);
      var w=measure.measureText(t).width-input.scrollLeft;
      blk.style.left=(ir.left-host.left+Math.max(0,Math.min(w,ir.width-blk.offsetWidth)))+'px';
      ph.style.left=(ir.left-host.left)+'px';
    }
    var typeT=null;
    function typing(){field.classList.add('is-typing');clearTimeout(typeT);typeT=setTimeout(function(){field.classList.remove('is-typing')},500)}
    function say(text,err){msg.classList.toggle('is-err',!!err);decode(msg,text,500)}
    function onFill(){
      var valid=EMAIL.test(input.value.trim());
      field.classList.toggle('has-value',!!input.value);
      if(valid&&!wasValid&&C.verified) say(C.verified,false);
      if(!valid&&wasValid&&!msg.classList.contains('is-err')) msg.textContent='';
      wasValid=valid;
    }
    input.addEventListener('focus',function(){field.classList.add('is-focus');place()});
    input.addEventListener('blur',function(){field.classList.remove('is-focus')});
    input.addEventListener('input',function(){
      if(msg.classList.contains('is-err')){msg.textContent='';msg.classList.remove('is-err')}
      typing();place();onFill();
    });
    input.addEventListener('keyup',place);
    ['click','select','scroll'].forEach(function(ev){input.addEventListener(ev,place)});
    document.addEventListener('selectionchange',function(){if(document.activeElement===input) place()});
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(function(){if(root.classList.contains('is-open')) place()});
    window.addEventListener('resize',function(){if(root.classList.contains('is-open')) place()});

    /* typing errors: the footer's 4 messages (07.10.2026) */
    function errorFor(v){
      if(!v) return C.errEmpty;
      var at=v.indexOf('@');
      if(at<0) return C.errAt||C.errInvalid;
      var dom=v.slice(at+1);
      if(!dom||dom.indexOf('.')<0||/\.$/.test(dom)) return C.errDomain||C.errInvalid;
      return C.errInvalid;
    }

    /* ---------- sending: Klaviyo only (08.10.2026) ----------
       Submit: check the address, show "> sending..." and wait the usual 450 ms,
       then send to Klaviyo. Klaviyo's answer decides the result screen.
       Nothing goes to Shopify, so Shopify's hCaptcha never attaches. */
    var sent=false;
    function send(){
      if(sent||busy) return;
      var email=input.value.trim().toLowerCase();
      if(!EMAIL.test(email)) return;
      busy=true;
      sendChecked(email);
    }
    async function sendChecked(email){
      if(knownEmails().indexOf(email)>-1||lsGet(DONE_KEY)===email){
        await sleep(reduced?0:450);
        finish('exists',email);
        return;
      }
      /* trap field filled: the success screen, nothing is sent */
      if(trapFilled(form)){
        await sleep(reduced?0:450);
        sent=true;
        finish('ok',email);
        return;
      }
      var guard=spamGuard(email);
      if(guard==='throwaway'){say('> error: use your own email address, not a throwaway one.',true);busy=false;return}
      if(guard==='limit'){say('> error: too many sign-ups from this device. Try again in an hour.',true);busy=false;return}
      /* 09.10.2026: already subscribed in Klaviyo (any device): Already registered, nothing sent */
      var reg=(await Promise.all([crRegistered(email,trapValue(form)),sleep(reduced?0:450)]))[0];
      if(reg){finish('exists',email);return}
      logSend();
      var ok=await klaviyoSubscribeChecked(email,KL_SOURCE,KL_SOURCE_KEY);
      if(ok){sent=true;finish('ok',email)}
      else finish('error');
    }
    /* any code that calls form.submit() still lands in send() */
    form.submit=function(){send()};

    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(busy||sent) return;
      var email=input.value.trim().toLowerCase();
      if(!EMAIL.test(email)){wasValid=false;say(errorFor(email),true);return}
      busy=true;
      if(C.sending) say(C.sending,false);
      sendChecked(email);
    });

    root.addEventListener('click',function(e){
      var t=e.target.closest('[data-mxnl-act]');
      if(t&&t.getAttribute('data-mxnl-act')==='close') close();
    });
    root.addEventListener('keydown',function(e){if(e.key==='Escape') close()});

    /* ---------- back from Shopify's check page (or a browser without fetch) ---------- */
    var pending=null;
    try{pending=JSON.parse(ssGet(PENDING_KEY))}catch(e){}
    if(pending){
      ssDel(PENDING_KEY);
      var kind=pending.local||resultFlag||'';
      if(kind){
        if(kind==='ok'||kind==='exists'){rememberEmail(pending.email);lsSet(DONE_KEY,pending.email)}
        if(history.replaceState){
          var u=new URL(location.href);u.searchParams.delete('customer_posted');u.hash='';
          history.replaceState(null,'',u.pathname+u.search);
        }
        showResult(kind);
        return;
      }
    }

    /* ---------- when to open ----------
       The newsletter never shows while the cookie window is on screen. Its
       delay (10 seconds by default) only starts at the moment the cookie
       window is clicked away. Same rule in the theme editor. */
    function cookieState(){
      var c=document.querySelector('[data-mxcc]');
      if(!c) return 'none';
      return c.getAttribute('data-mxcc-state')||'pending';
    }
    function cookieBusy(){var st=cookieState();return st!=='none'&&st!=='closed'}
    function schedule(){clearTimeout(timer);timer=setTimeout(safeOpen,Math.max(0,openDelay)*1000)}
    function safeOpen(){if(cookieBusy()) return;open()}
    function onCookieDone(){if(!cookieBusy()) schedule()}
    /* the cookie window (re)opens: step aside and wait for it again */
    function onCookieOpen(){clearTimeout(timer);if(root.classList.contains('is-open')){root.classList.remove('is-open')}}
    document.addEventListener('mxcc:open',onCookieOpen);

    /* may this visitor see the window at all? */
    var allowed=true;
    if(design) allowed=!!C.preview;
    else{
      if(lsGet(DONE_KEY)) allowed=false;
      var d=+lsGet(DISMISS_KEY);
      if(d&&Date.now()-d<dismissDays*864e5) allowed=false;
    }
    function onClosed(){if(allowed&&!root.classList.contains('is-open')) onCookieDone()}
    function onReady(e){if(allowed&&!(e.detail&&e.detail.shown)) onCookieDone()}
    /* the 10 seconds start when the cookie window has fully closed */
    document.addEventListener('mxcc:closed',onClosed);
    document.addEventListener('mxcc:ready',onReady);

    /* 18.10.2026: the cookie script never started (blocked by an ad or cookie
       blocker): wait at most 3 seconds, then carry on as if there is no cookie window */
    var fallback=setTimeout(function(){
      var c=document.querySelector('[data-mxcc]');
      if(allowed&&c&&!c.hasAttribute('data-mxcc-state')&&!root.classList.contains('is-open')){
        c.setAttribute('data-mxcc-state','closed');
        schedule();
      }
    },3000);

    root._mxnlDestroy=function(){
      clearTimeout(timer);clearTimeout(fallback);
      document.removeEventListener('mxcc:open',onCookieOpen);
      document.removeEventListener('mxcc:closed',onClosed);
      document.removeEventListener('mxcc:ready',onReady);
      root.remove();
    };

    if(allowed&&!cookieBusy()) schedule();
  }

  function boot(){document.querySelectorAll('[data-mxnl]').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();

  document.addEventListener('shopify:section:unload',function(e){
    document.querySelectorAll('[data-mxnl]').forEach(function(r){
      if(r.getAttribute('data-section-id')===e.detail.sectionId&&r._mxnlDestroy) r._mxnlDestroy();
    });
  });
  document.addEventListener('shopify:section:load',function(e){
    var fresh=e.target.querySelector('[data-mxnl]');
    if(fresh) init(fresh);
  });
})();